import Helper from './Helper';

class Gri {
  constructor() {
    this.link = Array.from(document.querySelectorAll('span.link'));
    this.parentTable = null;
    this.parentCol = null;
    this.parentTD = null;
    this.prevSibling = null;
    this.siblingContent = null;
    this.linkContent = null;

    if (this.link.length > 0) {
      this.bindEventsOnLoad();
    }
  }

  bindEventsOnLoad() {
    this.link.forEach((item) => {
      this.parentTable = Helper.getClosest(item, 'table');
      this.parentTD = Helper.getClosest(item, 'td');
      this.prevSibling = this.parentTD.previousElementSibling;
      this.siblingContent = this.prevSibling.querySelector('span');
      this.linkContent = this.parentTD.querySelector('span');

      if (item.querySelector('a')) {
        // Extract text content from sibling
        const textParts = this.siblingContent.innerHTML
          .split('\n')
          .map(part => part.trim())
          .filter(part => part.length > 0);

        // Extract links properly from the `this.linkContent` span
        const linksInTD = Array.from(this.linkContent.querySelectorAll('a'));
        const hrefs = linksInTD.map(link => link.getAttribute("href")); // Get all hrefs
        const linkTexts = linksInTD.map(link => link.textContent.trim()); // Get displayed text inside <a>

        //console.log('Extracted hrefs:', hrefs);
        //console.log('Extracted link texts:', linkTexts);

        this.siblingContent.innerHTML = '';

        textParts.forEach((textPart, index) => {
          if (index < hrefs.length) {
            const newATag = document.createElement("a");
            newATag.classList.add('gri-link');
            newATag.setAttribute('href', hrefs[index]);

            // Open external links in a new tab
            if (hrefs[index].indexOf(window.location.host) === -1 &&
              (hrefs[index].startsWith('http://') || hrefs[index].startsWith('https://'))) {
              newATag.setAttribute('target', '_blank');
            }

            newATag.textContent = textPart || linkTexts[index] || hrefs[index]; // Use extracted text or fallback

            this.siblingContent.appendChild(newATag);
          } else {
            this.siblingContent.appendChild(document.createTextNode(textPart));
          }

          // Add <br> for multiple text parts
          if (index < textParts.length - 1) {
            this.siblingContent.appendChild(document.createElement('br'));
          }
        });
      }

      // Modify table and remove the processed TD
      Helper.addClass(this.parentTD, 'js-modified');
      this.parentTD.parentNode.removeChild(this.parentTD);
      Helper.addClass(this.parentTable, 'js-modified');
    });
  }
}

export default Gri;
